import __vue_component__ from './IconWrapper.vue.js';

var VidVolumeMutedIcon = {
  name: 'VidVolumeMutedIcon',
  props: {
    size: {
      type: String
    },
    primaryColor: {
      type: String
    },
    secondaryColor: {
      type: String
    }
  },

  render(h) {
    // eslint-disable-next-line max-len
    return h(__vue_component__, {
      props: { ...this.$props
      },
      domProps: {
        innerHTML: '<svg viewBox="0 0 24 24"><path d="M14 16.001v4.05a.5.5 0 0 1-.806.395l-4.962-3.834H3.999c-.552 0-.999-.453-.999-.997V9.609c0-.55.441-.997.999-.997H6.61L3.705 5.707a.996.996 0 0 1 .002-1.413.996.996 0 0 1 1.413-.001l15.003 15.003a.996.996 0 0 1-.002 1.413.996.996 0 0 1-1.412.001L14 16.001zm5.829.495l-1.112-1.112c.522-.803.776-1.738.776-2.816 0-2.076-.942-3.601-2.917-4.672-.372-.202-.522-.69-.335-1.09.187-.4.64-.561 1.012-.36C19.72 7.784 21 9.856 21 12.568c0 1.507-.396 2.822-1.171 3.928zm-2.28-2.28l-1.153-1.152c.045-.152.066-.315.066-.494 0-.637-.274-1.082-.915-1.429-.372-.201-.522-.689-.335-1.09.188-.4.64-.56 1.012-.36 1.133.614 1.745 1.606 1.745 2.88 0 .616-.144 1.168-.42 1.645zM14 10.669l-3.724-3.723 2.918-2.254a.5.5 0 0 1 .806.395v5.582z" fill="currentColor" fill-rule="evenodd"/></svg>'
      }
    });
  }

};

export default VidVolumeMutedIcon;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Icon/VidVolumeMutedIcon.js